
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"124","height":"124"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"124","height":"124","fill":"#3D2562","rx":"16"}}),_c('path',{attrs:{"fill":"#FFF","d":"M81.153 35.54l7.307 7.307a5.165 5.165 0 010 7.306l-7.307 7.307a5.162 5.162 0 01-1.07.823v9.21c4.457 1.146 7.75 5.192 7.75 10.007 0 5.707-4.626 10.333-10.333 10.333S67.167 83.207 67.167 77.5c0-4.815 3.292-8.86 7.749-10.007v-9.21a5.223 5.223 0 01-1.07-.823l-7.306-7.307a5.162 5.162 0 01-.823-1.07h-9.21a10.348 10.348 0 01-7.424 7.425v10.659h2.584a5.166 5.166 0 015.166 5.166v10.334a5.166 5.166 0 01-5.166 5.166H41.333a5.166 5.166 0 01-5.166-5.166V72.333a5.166 5.166 0 015.166-5.166h2.583v-10.66c-4.457-1.147-7.75-5.192-7.75-10.007 0-5.707 4.627-10.333 10.334-10.333 4.815 0 8.86 3.293 10.008 7.75h9.21c.22-.383.495-.743.822-1.07l7.307-7.307a5.165 5.165 0 017.306 0zM51.667 72.333H41.333v10.334h10.334V72.333zm25.833 0a5.168 5.168 0 10.002 10.336 5.168 5.168 0 00-.002-10.336zm0-33.14L70.193 46.5l7.307 7.307 7.307-7.307-7.307-7.307zm-31 2.14a5.168 5.168 0 10.002 10.336 5.168 5.168 0 00-.002-10.336z"}})])])
          )
        }
      }
    